import React from "react";
import { PanelLayout } from "../../layout/Panel/Panel";
import { Spacing } from "../../layout/Spacing/Spacing";
import { Loader } from "../Loader/Loader";
import { FlexCenter } from "../../layout/FlexCenter/FlexCenter";
import { TextCustom } from "../../ui/TextCustom";

interface ILoaderBackgroundProps {
    label: string,
    position?: 'fixed' | 'absolute' | 'relative';
    hasPanel?: boolean
}

export const LoaderBackground: React.FC<ILoaderBackgroundProps> = ({label, position = 'fixed', hasPanel = true}) => {

    const content = <Spacing paddingSpacing="s" marginSpacing="s">
                        <FlexCenter position="center" direction="v">
                            <Loader height={15} width={15} color="dark" hasText={false}/>
                            <TextCustom size={1} color="grey-dark">{label}</TextCustom>
                        </FlexCenter>
                    </Spacing>

    return (
        <div className={`user-settings-background-loader user-settings-background-loader--${position}`}>
            {
                hasPanel
                ?
                <PanelLayout>
                    {content}
                </PanelLayout>
                :
                <div>{content}</div>
            }
        </div>
    )
}